// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__SC6kN","notFoundText":"NotFound_notFoundText__ZORbU","homeLink":"NotFound_homeLink__Zitut"};